import { createRouter, createWebHistory } from 'vue-router'
import System from './modules/system'
import dashboard from './modules/dashboard'
import page from './modules/page'

// const files = require.context('./modules', false, /\.js$/);
/* const modules = {}
files.keys().forEach((key) => {
  // modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
  console.log("查找到的", files(key).default);
}) */

let routes = [ ...System, ...dashboard, ...page ]

const router = createRouter({ 
  history: createWebHistory(), 
  routes 
})

/* export {
  modules
} */

export default router
